import { useFeatureFlag, FEATURE_FLAGS } from "../../contexts";
import { formatGoalCompact } from "./constants";

/**
 * Amount formatter for the goal surfaces (widget card and tooltip, breakdown
 * modal, goals settings modal). Behind ESTIMATED_GOAL_PILL it keeps one decimal
 * on thousands and millions ("$1.3K", not "$1K"), so a small book's goal stays
 * readable; flag off it is the old whole-number compact format.
 */
export const useGoalAmountFormat = () => {
  const precise = useFeatureFlag(FEATURE_FLAGS.ESTIMATED_GOAL_PILL);
  return (value) => formatGoalCompact(value, precise);
};
